module.exports = __webpack_public_path__ + "img/mz.9505f89b.png";